import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TaskCreateNewComponent } from './create-new/create-new.component';
import { TaskMainViewComponent } from './main-view/main-view.component';

const ROUTES: Routes = [
  {
    path: '',
    component: TaskMainViewComponent
  },
  {
    path: 'new',
    component: TaskCreateNewComponent
  },
  {
    path: '*',
    redirectTo: '',
    pathMatch: 'full'
  }
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(ROUTES)],
  exports: [RouterModule]
})
export class TaskRoutingModule {}
